import { inject, Injectable } from '@angular/core';
import { UrlTree, CanLoad, Route, UrlSegment, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard implements CanLoad {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    if (this.authService.isAuthenticated$$()) {
      this.router.navigateByUrl('/tabs');
      return of(false);
    }
    return of(true);
  }
}
